<div class="container h-100" *transloco="let t; read: 'ime.login.enter-password'">
  <div class="row">
    <div class="col">
      <h1 class="text-center text-white">
        <img class="d-block mx-auto w-25" src="assets/img/logo_ETSNord_white.svg" alt="ETSNord logo">
      </h1>
      <p class="lead text-center text-white my-4">{{t('Sisesta oma salasõna')}}</p>
    </div>
  </div>
  <div class="row align-items-center justify-content-center mt-1">
    <div class="col-sm-6">
      <div class="card">
        <div class="card-body p-4">
          <h2 class="text-center">{{name}}</h2>
          <div class="input-group my-4">
            <input type="password" [(ngModel)]="password" class="form-control form-control-lg" placeholder="Salasõna">
            <button class="btn btn-primary px-4" type="button" (click)="loginWithPassword()">{{t('Sisene')}}</button>
          </div>
          <mes-api-response-summary [response]="errorResponse"></mes-api-response-summary>
        </div>
      </div>
    </div>
  </div>
</div>
